import { RateOption } from "./dataModel";
import { assertUnreachable } from "lib/assertUnreachable";

/**
 * Returns the worst case (highest) execution count per month:
 *
 * - If something runs daily, worst case is a month with 31 days.
 * - If something runs every Monday, worst case is a month with five
 *   Mondays.
 * - Add an extra hour to the month to account for daylight savings
 *   time, which in some timezones makes October one hour longer.
 */
export function getMaxExecutionCountPerMonth(option: RateOption): number {
  const hoursPerMonth = 31 * 24 + 1;

  switch (option) {
    case "15 minutes":
      return 4 * hoursPerMonth;

    case "20 minutes":
      return 3 * hoursPerMonth;

    case "30 minutes":
      return 2 * hoursPerMonth;

    case "1 hour":
      return hoursPerMonth;

    case "2 hours":
      return Math.ceil(hoursPerMonth / 2);

    case "3 hours":
      return Math.ceil(hoursPerMonth / 3);

    case "4 hours":
      return Math.ceil(hoursPerMonth / 4);

    case "6 hours":
      return Math.ceil(hoursPerMonth / 6);

    case "8 hours":
      return Math.ceil(hoursPerMonth / 8);

    case "12 hours":
      return Math.ceil(hoursPerMonth / 12);

    case "Day":
      return 31;

    case "Every Monday":
    case "Every Tuesday":
    case "Every Wednesday":
    case "Every Thursday":
    case "Every Friday":
    case "Every Saturday":
    case "Every Sunday":
      return 5;

    default:
      assertUnreachable(option);
  }
}
